var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"small":_vm.small,"color":_vm.currentStatus.color,"icon":_vm.icon,"disabled":_vm.disabled,"loading":_vm.loading},on:{"click":_vm.run}},[_c('v-icon',{attrs:{"small":_vm.small}},[_vm._v(_vm._s(_vm.currentStatus.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }